import React, { useEffect, useState, Fragment } from 'react';
import Modal from '../Modal/modal';
import withErrorhandler from '../../../hoc/withErrorHandler/withErrorHandler';
import { SuccessDes } from '../../components/PopUp/CommonSvgs';
import succSmiley from '../../../images/icons/succSmiley.svg';
import styles from './styles.module.css';

const RatingModal = ({
  modalOpen,
  setModalOpen,
  ratingIcon,
  ratingOptions,
  ratingTextOptions,
  submitFeedback
}) => {
  const [rating, setRating] = useState('');
  const [feedback, setFeedback] = useState('');
  const [ratingText, setRatingText] = useState('Give us your rating');
  const [submitted, setSubmitted] = useState(false);
  const { ratingContainer, icons } = styles;

  useEffect(() => {
    return () => {
      setSubmitted(false);
      setModalOpen(false);
    };
  }, []);

  return (
    <Modal show={modalOpen} setShow={setModalOpen}>
      {!submitted ? (
        <div className="mx-auto my-4 modal">
          <Fragment>
            <div className="text-center">
              <h1 className="text-lg md:text-3xl xxl:text-4xl text-grey-600 font-semibold my-4">
                {ratingText}
              </h1>
              <div
                className={`flex flex-row-reverse justify-center my-4 ${ratingContainer}`}
              >
                {ratingOptions.map(num => (
                  <React.Fragment key={num}>
                    <input
                      type="radio"
                      id={`star${num}`}
                      name="star"
                      value={num}
                      onChange={() => {
                        setRating(num);
                        setRatingText(ratingTextOptions[num]);
                      }}
                    />
                    <label className={`${icons}`} htmlFor={`star${num}`}>
                      {ratingIcon}
                    </label>
                  </React.Fragment>
                ))}
              </div>
            </div>
            <div className="my-2">
              <p className="text-sm md:text-xl xxl:text-2xl text-grey-600">
                What were you impressed with?
              </p>
              <textarea
                rows="4"
                placeholder="Enter your feedback (optional)"
                className="w-full p-2 my-2 border border-blue-1103"
                style={{ resize: 'none' }}
                value={feedback}
                onChange={e => setFeedback(e.target.value)}
              ></textarea>
              <p className="text-sm md:text-base xxl:text-xl text-grey-600 my-4">
                Your words make Fincity a better place. You are the influence!
              </p>
              <div className="text-center my-4">
                <button
                  className="submitButton w-40"
                  disabled={!rating}
                  onClick={() =>
                    submitFeedback({
                      rating: rating,
                      comment: feedback
                    })
                      .then(res => {
                        setSubmitted(true);
                      })
                      .catch(err => {})
                  }
                >
                  Submit
                </button>
              </div>
            </div>
          </Fragment>
        </div>
      ) : (
        <div className="flex flex-col justify-around w-full min-h-80v ">
          <div
            className="w-full mx-auto bg-white text-center"
            style={{ width: 'fit-content' }}
          >
            <div className="mx-auto" style={{ width: 'fit-content' }}>
              <SuccessDes />
            </div>
            <p
              className="mx-auto font-medium self-start"
              style={{ color: '#064E55 ' }}
            >
              Thanks for the feedback
            </p>
            <div className="inline-flex pt-3 content-start">
              <span className="text-black-200 text-base font-sans font-medium mr-2">
                You are Awesome !!
              </span>
              <img src={succSmiley} className="w-10 h-10 -mt-2 " alt="-_-" />
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default withErrorhandler(RatingModal);
